import { Pill } from "@dashboard/components/Pill";
import { OrderDetailsFragment } from "@dashboard/graphql";
import { transformPaymentStatus } from "@dashboard/misc";
import {
  derivePaymentPillState,
  getDerivedPaymentPillLabel,
} from "@dashboard/orders/utils/paymentStatusPill";
import React from "react";
import { useIntl } from "react-intl";

type Order = Pick<OrderDetailsFragment, "paymentStatus" | "chargeStatus"> &
  Partial<Pick<OrderDetailsFragment, "totalCharged" | "totalRefunded" | "totalGrantedRefund">>;

export interface OrderPaymentStatusPillProps {
  order: Order | undefined;
  className?: string;
}

export const OrderPaymentStatusPill = ({ order, className }: OrderPaymentStatusPillProps) => {
  const intl = useIntl();

  if (!order) {
    return null;
  }

  const pillState = derivePaymentPillState(order);

  if (pillState !== "default") {
    const { label, status } = getDerivedPaymentPillLabel(pillState, intl);

    return (
      <Pill
        key={pillState}
        label={label}
        color={status}
        style={{ alignSelf: "flex-end" }}
        className={className}
      />
    );
  }

  const payment = transformPaymentStatus(order.paymentStatus, intl);

  return (
    <Pill
      key={payment.status}
      label={payment.localized}
      color={payment.status}
      style={{ alignSelf: "flex-end" }}
      data-test-id="payment-status"
      className={className}
    />
  );
};
